import React, { useRef, useState, useEffect } from 'react'
import { Button, Modal } from 'antd'
import { useHistory } from 'react-router'
import { useReactToPrint } from 'react-to-print'
import { ProjectCartaFactura } from './ProjectCartaFactura'

const ContentModalMainProject = ({ getProject, getProductsNotAvailable, setProjectData, setActiveKey, setVisible, visible, setAddProducts, onChangeView }) => {
  const [total, setTotal] = useState(0)
  const [flag, setFlag] = useState(false)

  const history = useHistory()

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <ProjectCartaFactura ref={componentRef} getProject={getProject} />
      default:
        break;
    }
  }

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [total, flag])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const handleFlagPrint = (key) => {
    setTotal(key)
    setFlag(!flag)
  }

  const onEditConfirm = async (getProject, key) => {
    const auxDate = new Date(getProject?.date)

    let birthday = auxDate
    let today = new Date()
    const x = parseInt((birthday - today))
    const day = (Math.ceil(x / (1000 * 60 * 60 * 24)));
    const products = getProject.project_details.map(item => {
      let discount_level = ''
      let discount_amount = 0

      item.presentation.discount_presentation.forEach(p => {
        if (item.discount_id === p.pivot.discount_id) {
          discount_level = p.discount_level

          discount_amount = parseFloat(p.pivot.discount_amount)
        }
      });

      const obj = {
        id: item.id,
        discount_id: item.discount_id,
        discount_amount: parseFloat(discount_amount),
        product: item.presentation.id,
        description: item.presentation.description,
        price: item.price,
        units: parseFloat(item.quantity),
        total: item.sub_total,
        type: item.presentation.presentation_combo_id ? 'COMBO' : 'PRESENTATION',
        discount_level: discount_level
      }

      console.log("ContentModalMainProject onEditConfirm obj ==>", obj);
      return obj
    })

    const obj = {
      id: getProject.id,
      client: getProject.client,
      products: products,
      status: getProject.status,
      notes: getProject.notes,
      day: day,
      total: getProject.total,
      origin_reason: getProject.origin_reason,
      destination_reason: getProject.destination_reason,
    }

    setProjectData(obj)
    setActiveKey('9')

    setTimeout(function () {
      setActiveKey(key)
      setVisible(false)
      setAddProducts(false)
      onChangeView(true)
    }, 500);
  }

  return (
    <Modal
      visible={visible}
      centered
      footer={[
        <Button key="submit" type="primary" onClick={() => history.go(0)} className={'title-tendero new-button'}>
          Continuar
        </Button>
      ]}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'none' }}>{returnPrint(total)}</div>
        <br></br>
        {
          <div style={{ display: 'grid', justifyContent: 'center' }}>
            <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => handleFlagPrint(1)}>
              Imprimir hoja de salida
            </Button>

            <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => onEditConfirm(getProject, '7')}>
              Editar
            </Button>

            <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => onEditConfirm(getProject, '1')}>
              Facturar
            </Button>

            <Button onClick={() => getProductsNotAvailable()} style={{ backgroundColor: "rgb(205, 205, 205)", color: 'white', borderColor: '#cdcdcd' }} className="title-tendero new-button" >
              Ver inventario bajo
            </Button>
          </div>
        }
      </div >
    </Modal>
  )
}

export default ContentModalMainProject